import { Grid } from '@material-ui/core';
import styled from 'styled-components';

import { AssuranceIcon } from 'images';
import { LargeSectionHeader, LongBody } from 'components/Typography';
import { get } from 'lodash';

const StyledGridImg = styled(Grid)`
  width: 100%;
  height: 343px;
`;

const StyledGrid = styled(Grid)`
  background-color: #fff;
`;
const StyledImgDiv = styled.div`
  background-image: url(${(props: { backgroundImage: string }) =>
    get(AssuranceIcon, props.backgroundImage, 'house')});
  background-repeat: no-repeat;
  background-position: 36%;
  background-size: cover;
  width: 100%;
  height: 100%;
`;

const StyledLongBody = styled(LongBody)`
  && {
    font-weight: 300;
    line-height: 30px;
  }
`;

const StyledLargeSectionHeader = styled(LargeSectionHeader)`
  && {
    margin-bottom: 0;
  }
`;

export {
  StyledGridImg,
  StyledGrid,
  StyledImgDiv,
  StyledLongBody,
  StyledLargeSectionHeader,
};
